import { Modal } from "bootstrap";

const addImageListeners = () => {
  const popupImageContainer = document.getElementById("popup-image-container");
  const popupImageLabelText = document.getElementById("image-popup-label-text");
  const popupImageLabelTime = document.getElementById("image-popup-label-time");

  if (!popupImageContainer) throw new Error("popup-image-container not found");
  if (!popupImageLabelText) throw new Error("image-popup-label-text not found");
  if (!popupImageLabelTime) throw new Error("image-popup-label-time not found");

  document
    .querySelectorAll(".popup-image:not([data-listened])")
    .forEach((element) => {
      if (!(element instanceof HTMLImageElement)) return;

      element.addEventListener("click", (e) => {
        const image = e.currentTarget as HTMLImageElement;
        const imagePopup = new Modal("#image-popup");

        popupImageContainer.innerHTML = `
          <img
            src="${image.getAttribute("src")}"
            class="rounded-2 border shadow"
          />
        `;

        if (image.dataset.title) {
          popupImageLabelText.innerHTML = image.dataset.title;
        }

        if (image.dataset.time) {
          popupImageLabelTime.innerHTML = image.dataset.time;
        }

        imagePopup.show();
      });
      element.dataset["listened"] = "true";
    });
};

document.addEventListener("DOMContentLoaded", addImageListeners);
document.addEventListener("ajax:success", addImageListeners);
document.addEventListener("reload-image-listeners", addImageListeners);
